import React from 'react';
import { DatePicker } from "@progress/kendo-react-dateinputs";

export default class EstimateDatePanel extends React.Component {

    constructor(props) {
        super(props);

        this.today = new Date();
        this.today.setHours(0, 0, 0, 0);
    }

    handleDateOfServiceChange = (e) => {
        this.props.onDateOfServiceChange(e.value);
    }

    render() {
        return (
            <div id={this.props.id} className="card shadow">
                <div className="card-body">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-4 col-lg-6">
                                <label className="form-label">Estimate Date</label>
                            </div>
                            <div className="col-sm-4 col-lg-6">
                                <input
                                    className="form-control"
                                    readOnly
                                    value={this.props.estimateDate.toLocaleDateString()}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4 col-lg-6">
                                <label className="form-label">Date of Service</label>
                            </div>
                            <div className="col-sm-4 col-lg-6">
                                <DatePicker
                                    defaultValue={this.today}
                                    onChange={this.handleDateOfServiceChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}